module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("PROPHETIC SIGNIFICANCE OF HOSEA’S FAMILY"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Hosea+1%3A4-11&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("HOSEA 1:4-11")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" God in Hosea revealed that he would send salvation through his Son, although still in a veiled manner (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY")]), _vm._v("). It is proposed here that salvation is not of this world based upon earthly wisdom but rather from God alone (N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVATIAN")]), _vm._v("). The Jews were chastised for rejecting Christ, and this in turn denied them any peace with God. Moreover, peace belongs to the church, the new people, loyal servants, who have returned to God through Christ (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). Jews showed they lacked wisdom having lost peace with God, since they refused to drink of the living water, which is Christ (S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIAN")]), _vm._v("). Hosea foretold the salvation of the Gentiles, who, once having been outcasts in the old covenant, are given full access to the kingdom. The apostles affirmed this prophecy by announcing the spiritual adoption of the Gentiles as sons of Abraham (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). “They shall go up” is interpreted as a reference to resurrection (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-029"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:7 "), _c('i', [_vm._v("Pity for Judah")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVEALS")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TERNAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAN.")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": He says to Hosea the prophet, “I will not add any more to have mercy on the house of Israel, but as their adversary I shall oppose them. But I shall have mercy on the sons of Judah, and I shall save them by the Lord their God.” The Father unmistakably gives the name of God to his Son in whom he chose us before the eternal ages. For this reason he says “their God,” because the unborn God is from no one, and God the Father has given us as an inheritance to his Son. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY 4.37.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD.")])]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVATIAN")]), _vm._v(": Why, then, should we hesitate to say what Scripture does not hesitate to say? Why should the truth of faith waver where the authority of Scripture has never faltered? For behold, the prophet Hosea says in the person of the Father, “I will not save them by bow nor horses, but I will save them by the Lord their God.” If God says that he will save them by God and if God does not save except by Christ, then why should people hesitate to call Christ God when they realize that the Father declares, through the Scriptures, that he is God? In fact, if God the Father cannot save except by God, no one can be saved by God the Father, unless one has acknowledged that Christ is God, in whom and through whom the Father promises to grant salvation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY 12.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-030"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:9"), _c('i', [_vm._v(" Not My People")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTILES")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVED.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": “For he proclaims peace to his people, and to his faithful ones, and to those who turn to him from their hearts.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" I note here a threefold classification: his "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("people, his loyal servants, and those who come back to him in hope. He proclaims peace to his people, not to the Jews of whom in Hosea he says, “You are not my people.” H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS,")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LTERNATE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIES 64.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETIC")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EJECTION OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS.")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIAN THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESBYTER")]), _vm._v(": For this reason, our God spoke elsewhere about the Hebrew people to the prophet, saying, “Call his name Not Beloved,” and again to the Jews, “You are not my people, and I am not your God.” But he himself showed clearly elsewhere why he said this about them, for he said, “They have forsaken the Lord, the vein of living waters,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" and again, “For they have cast away the word of the Lord, and there is no wisdom in them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVERNANCE OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD 4.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-031"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:10 "), _c('i', [_vm._v("Children of the Living God")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTILE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORETOLD.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": Because Hosea is such a profound prophet, it is no easy matter to get at his meaning. Still, I must keep my promise and quote something from him at this point. He says, “And it shall be in the place where it was said to them, ‘You are not my people’; it shall be said to them, ‘You are sons of the living God.’” The apostles themselves understood this text as a prophecy of the calling of the Gentiles, who were previously not God’s people."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" And because the Gentiles are spiritually sons of Abraham and correctly therefore alluded to as Israel, Hosea goes on to say, “And the children of Judah and the children of Israel shall be gathered together, and they shall appoint themselves one head, and they shall come up out of the earth.” Now to add one word of explanation to this text would be to lose the savor of Hosea’s prophetic style. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD 18.28.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-032"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:11"), _c('i', [_vm._v(" They Shall Go Up")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMUNITY OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH “")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HALL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.”")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": “They come up out of the land,” namely, they will live the life of the saints as well, “for great is the day of Jezreel.” Indeed, great is the day of Christ, when he will raise to life all the dead. In fact, he will descend from heaven and sit on his glorious throne. “And he will give everyone according to his works.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Therefore if one wishes to understand by “day” the time of the visitation—when the remission of sins is given by Christ to the Greeks, the Judaeans and those who have sinned against him—this will not deviate from the true words. For David too indicated the time of the coming of our Savior by saying, “This is the day that the Lord has made; let us be glad and rejoice in it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 1.9.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098def88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap3.vue
// module id = 87
// module chunks = 0